const getLocationPathname = (value) => {
  const pathArray = value.split('/');

  if (pathArray[3] === 'kiosks') {
    return `/${pathArray[1]}/${pathArray[2]}/kiosks`;
  } else if (pathArray[3] === 'website') {
    return `/${pathArray[1]}/${pathArray[2]}/website`;
  } else if (pathArray[3] === 'bank-accounts') {
    return `/${pathArray[1]}/${pathArray[2]}/${pathArray[3]}`;
  } else if (pathArray[3] === 'payouts' || pathArray[3] === 'payoutsv3') {
    return `/${pathArray[1]}/${pathArray[2]}/payouts`;
  } else return;
};

export { getLocationPathname };
